import React, { useRef, useState } from "react";
import { ReactSketchCanvas } from "react-sketch-canvas";
import { Form } from "react-bootstrap";
import { BtnAyuda } from "./BtnAyuda";
import { Eraser, Redo, Undo, Pen, RotateCcw, Check, Trash2 } from "lucide-react";

const SignatureDrawer = ({ item, esEditable, index, idx, reg, error }) => {
  const canvasRef = useRef(null);
  const [eraserSize, setEraserSize] = useState(15);
  const [eraseMode, setEraseMode] = useState(false);
  const [signature, setSignature] = useState(item.valor ? item.valor : "");
  const [isConfirmed, setIsConfirmed] = useState(item.valor ? true : false);

  const clearSignature = (e) => {
    e.preventDefault();
    canvasRef.current.clearCanvas();
    setSignature("");
    setIsConfirmed(false);
  };

  const handleErase = (e) => {
    e.preventDefault();
    setEraseMode(true);
    canvasRef.current.eraseMode(true);
  };

  const handlePenDrawing = (e) => {
    e.preventDefault();
    setEraseMode(false);
    canvasRef.current.eraseMode(false);
  }

  const handleEraseSizeChange = (e) => {
    setEraserSize(e.target.value);
  }

  const handleUndo = (e) => {
    e.preventDefault();
    canvasRef.current.undo();
  }

  const handleRedo = (e) => {
    e.preventDefault();
    canvasRef.current.redo();
  }

  const handleExport = async () => {
    const signature = await canvasRef.current.exportImage();
    setSignature(signature);
  };

  const handleConfirmToggle = (e) => {
    e.preventDefault();
    if (isConfirmed) {
      clearSignature(e);
    } else {
      handleExport();
      setIsConfirmed(true);
    }
  };

  return (
    <Form.Group style={{ display: 'block' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-start' }} >
        <Form.Label style={{ color: item.label_color ? item.label_color : "#000", fontSize: item.font_size ? item.font_size : "" }} >{item.titulo}{item.es_requerido === true && '*'}</Form.Label>
        {item?.ayuda &&
          <BtnAyuda ayuda={item.ayuda} />
        }
      </div>
      <ReactSketchCanvas
        id="signature"
        ref={canvasRef}
        strokeWidth={2}
        strokeColor="black"
        width="100%"
        height={item.height ? item.height : "150px"}
        className={`signature__drawer ${isConfirmed ? "confirmed" : ""}`}
        eraserWidth={eraserSize}
        backgroundImage={isConfirmed || signature ? signature : "" }
        allowOnlyPointerType="all"
        style={{ pointerEvents: isConfirmed ? 'none' : 'auto' }}
        canvasColor="transparent"
  
        />
      <input
        type="hidden"
        name={`asesoria.${index}.${item.nombre}`}
        value={signature}
        key={`${index} - ${idx}`}
        ref={reg}
        {...reg(`asesoria.${index}.${item.nombre}`, {
          required: item.es_requerido
        })}
      />
      <div className="controles__firma">
        <button onClick={handleConfirmToggle} title={isConfirmed ? "Rehacer" : "Confirmar"} className={isConfirmed ? "danger" : "success"} disabled={esEditable}>
          {signature ? <div><Trash2 /> Rehacer</div> : <div><Check /> Confirmar</div>}
        </button>
        <button onClick={handlePenDrawing} className={eraseMode ? "" : "active"} title="Dibujar" disabled={esEditable || isConfirmed}><Pen /></button>
        <div className="eraser__controls">
          <button onClick={handleErase} className={eraseMode ? "active" : ""} title="Borrador" disabled={esEditable || isConfirmed}><Eraser /></button>
          <input
            disabled={!eraseMode || esEditable || isConfirmed}
            type="range"
            min="1"
            max="30"
            value={eraserSize}
            onChange={(e) => handleEraseSizeChange(e)}
            title="Tamaño del borrador"
          />
        </div>
        <button onClick={handleUndo} title="Deshacer" disabled={esEditable || isConfirmed}><Undo /></button>
        <button onClick={handleRedo} title="Rehacer" disabled={esEditable || isConfirmed}><Redo /></button>
        <button onClick={clearSignature} title="Limpiar" disabled={esEditable || isConfirmed}><RotateCcw /></button>
      </div>
      {error ?
        (
          error.type === 'required' ?
            (
              <span className="inputsInvalid">
                Este campo es requerido, por favor confírmelo.
              </span>
            )
            : null)
        : null}
    </Form.Group>
  );
};

export default SignatureDrawer;
